import React, { KeyboardEventHandler } from 'react';
import clsx from 'clsx';
import Preloader from 'components/shared/Preloader';
import styles from './Button.module.scss';
import plus from '../../../images/new-icons/plus-dark-green.svg';
import minus from '../../../images/new-icons/minus-dark-green.svg';

type ButtonProps = {
  className?: string;
  onClick?: (e: any) => void;
  disabled?: boolean;
  wide?: boolean;
  secondary?: boolean;
  black?: boolean;
  success?: boolean;
  blue?: boolean;
  green?: boolean;
  red?: boolean;
  link?: boolean;
  small?: boolean;
  secondarySmall?: boolean;
  noHover?: boolean;
  skeleton?: boolean;
  iconBtn?: boolean;
  loading?: boolean;
  children?: React.ReactNode;
  submit?: boolean;
  purple?: boolean;
  yellow?: boolean;
  darkGreen?: boolean;
  yellowDarkGreen?: boolean;
  gray?: boolean;
  ligtGrey?: boolean;
  white?: boolean;
  bold?: boolean;
  style?: React.CSSProperties;
  onKeyDown?: any;
  count?: number;
  onIncrement?: (e: any) => void;
  onDecrement?: (e: any) => void;
  showCounter?: boolean;
  noHeight?: boolean;
  type?: 'button' | 'submit';
};

function Button({
  className = '',
  onClick = () => {},
  disabled = false,
  wide = false,
  secondary = false,
  success = false,
  link = false,
  blue = false,
  green = false,
  noHeight = false,
  red = false,
  skeleton = false,
  black = false,
  iconBtn = false,
  small = false,
  secondarySmall = false,
  noHover = false,
  loading = false,
  children = null,
  submit = false,
  purple = false,
  yellow = false,
  darkGreen = false,
  yellowDarkGreen = false,
  white = false,
  gray = false,
  ligtGrey = false,
  bold = false,
  onKeyDown,
  count = 0,
  onIncrement,
  onDecrement,
  showCounter = false,
  style,
  type = 'button',
}: ButtonProps) {
  return (
    <button
      type={type}
      className={clsx(
        styles.btn,
        wide && styles.wide,
        secondary && styles.secondary,
        success && styles.success,
        blue && styles.blue,
        green && styles.green,
        red && styles.red,
        link && styles.link,
        iconBtn && styles.iconBtn,
        skeleton && styles.skeleton,
        black && styles.btnBlack,
        small && styles.small,
        secondarySmall && styles.secondarySmall,
        noHover && styles.noHover,
        purple && styles.purple,
        yellow && styles.yellow,
        yellowDarkGreen && styles.yellowDarkGreen,
        darkGreen && styles.darkGreen,
        ligtGrey && styles.ligtGrey,
        gray && styles.gray,
        white && styles.white,
        bold && styles.btnBold,
        noHeight && styles.noHeight,
        showCounter && count > 0 && styles.counter,
        className,
      )}
      style={style}
      onClick={!showCounter || count === 0 ? onClick : undefined}
      disabled={disabled}
      onKeyDown={onKeyDown}
    >
      {loading ? (
        <Preloader inline />
      ) : showCounter && count > 0 ? (
        <div className={styles.counterContainer}>
          <img src={plus} alt="plus" className={styles.counterBtn} onClick={onIncrement} />
          <div className={styles.counterValue}>{count}</div>
          <img src={minus} alt="minus" className={styles.counterBtn} onClick={onDecrement} />
        </div>
      ) : (
        children
      )}
    </button>
  );
}

export default Button;
